import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-black text-white border-t-8 border-yellow-400" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-58">
          <ShieldCheckIcon className="w-24 h-24 text-yellow-400 mx-auto mb-6" data-id="element-59" />

          <h2 className="text-4xl md:text-5xl font-black text-white mb-8 uppercase tracking-wide" data-id="element-60">
            🔒 GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="text-xl md:text-2xl text-gray-300 space-y-4 mb-12 max-w-2xl mx-auto font-medium" data-id="element-61">
            <p data-id="element-62">Probalo durante 7 días completos.</p>
            <p data-id="element-63">Si no es para vos, te devolvemos el 100% del dinero.</p>
            <p className="text-yellow-400 font-bold" data-id="element-64">
              Sin preguntas. Sin letra chica.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl mb-12 shadow-2xl" data-id="element-65">
            <h3 className="text-3xl font-black text-red-500 mb-4" data-id="element-66">
              ❤️ La conexión no se posterga
            </h3>
            <p className="text-2xl font-bold text-white mb-2" data-id="element-67">
              No necesitás más tiempo.
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-68">
              Necesitás mejores momentos.
            </p>
          </div>

          <CTAButton text="👉 ACCEDÉ AHORA AL PACK 100 CITAS" data-id="element-69" />
        </motion.div>
      </div>
    </section>;
}